import { functions } from '@/firebase-config';
import { httpsCallable } from 'firebase/functions';

import type { BackendCommand, CommandClient } from '../contracts';

export class FirebaseCommandClient implements CommandClient {
  async call<TRequest, TResponse>(
    command: BackendCommand<TRequest, TResponse>,
    request: TRequest,
  ): Promise<TResponse> {
    const callable = command.options?.timeoutMs === undefined
      ? httpsCallable<TRequest, TResponse>(functions, command.name)
      : httpsCallable<TRequest, TResponse>(functions, command.name, { timeout: command.options.timeoutMs });
    const result = await callable(request);
    return result.data;
  }
}
